<template>
  <div class="calc">
    <div
      v-if="!isKioskMode && hasDualPricing"
      class="checkout-price-display"
    >
      <div class="price-display-title">
        Price Display
      </div>
      <div class="price-display-row">
        <div class="price-display-item">
          <span class="price-display-label">Cash Price</span>
          <span class="price-display-value">
            {{ currency }} {{ cashPrice.toFixed(2) }}
          </span>
        </div>
        <div class="price-display-item">
          <span class="price-display-label">Credit Card Price</span>
          <span class="price-display-value">
            {{ currency }} {{ creditCardPrice.toFixed(2) }}
          </span>
        </div>
      </div>
    </div>

    <h5
      v-if="!isKioskMode"
      class="checkout-title"
    >
      {{ $t("amountandpaymentmethod.amount-tendered") }}
    </h5>

    <div class="calc-win">
      {{ amountTendered.toFixed(2) }}
    </div>

    <div
      v-if="isKioskMode"
      class="calc-body mb-4 mb-lg-0"
    >
      <h5 class="checkout-title">
        How would you like to pay?
      </h5>
      <div class="calc-control1">
        <div
          v-for="(paymentType, index) in paymentTypes"
          :key="index"
        >
          <b-button
            variant="primary"
            class="disabled"
            @click="!isPaymentProcessing ? $emit('pay', paymentType) : null"
          >
            Pay with {{ paymentType.name }}
          </b-button>
        </div>
      </div>
    </div>

    <div
      v-if="!isKioskMode"
      class="calc-body mb-4 mb-lg-0"
    >
      <div class="calc-pin">
        <SimpleNumKeyboard
          :withconfirm="false"
          :type="0"
          :amount="amountTenderedString"
          :clear-on-input="isAmountPreFilled"
          @updated="$emit('type-num', $event)"
          @input-started="$emit('input-started')"
        />

        <h5 class="checkout-title w-100">
          {{ $t("amountandpaymentmethod.quick-cash-payment") }}
        </h5>
      </div>

      <CheckoutPaymentButtons
        wrapper-class="d-lg-none"
        :payment-types="paymentTypes"
        :amount-tendered="amountTendered"
        :refund-order-id="refundOrderId"
        :is-payment-processing="isPaymentProcessing"
        :min-tendered="0.01"
        @pay="$emit('pay', $event)"
      />
    </div>

    <div
      v-if="!isKioskMode"
      class="qash"
    >
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div
          v-for="(amount, index) in quickCash"
          :key="index"
          :class="'calc-set-'+index"
          class="calc-set"
          @click="$emit('type-custom', amount)"
        >
          {{ amount }}
        </div>

        <b-button
          v-if="hasTable"
          class="btn btn-primary"
          @click="$emit('go-to-table-orders')"
        >
          <span>
            {{ $t("orderscreen.split-bill") }}
          </span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleNumKeyboard from "@/components/SimpleNumKeyboard";
import CheckoutPaymentButtons from "@/components/OrderCheckout/CheckoutPaymentButtons.vue";

export default {
  name: "CheckoutTenderPad",
  components: {
    SimpleNumKeyboard,
    CheckoutPaymentButtons,
  },
  props: {
    isKioskMode: {
      type: Boolean,
      default: false,
    },
    hasDualPricing: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: "",
    },
    cashPrice: {
      type: Number,
      default: 0,
    },
    creditCardPrice: {
      type: Number,
      default: 0,
    },
    amountTendered: {
      type: Number,
      default: 0,
    },
    amountTenderedString: {
      type: String,
      default: "0",
    },
    isAmountPreFilled: {
      type: Boolean,
      default: false,
    },
    paymentTypes: {
      type: Array,
      default: () => [],
    },
    isPaymentProcessing: {
      type: Boolean,
      default: false,
    },
    refundOrderId: {
      type: [Number, String],
      default: null,
    },
    quickCash: {
      type: Array,
      default: () => [],
    },
    hasTable: {
      type: [Boolean, Number, String],
      default: false,
    },
  },
};
</script>
